// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3W5Cl","list":"PatternAutocomplete_list__2CFx-"};